import type { MedalTier } from "./assignMedalTiers";

export function medalScoreThresholds(
  entries: ReadonlyArray<{ score: number }>,
): Record<MedalTier, number | null> {
  const distinct: number[] = [];
  for (const { score } of entries) {
    if (distinct[distinct.length - 1] !== score) {
      distinct.push(score);
      if (distinct.length === 3) {
        break;
      }
    }
  }
  return {
    gold: distinct[0] ?? null,
    silver: distinct[1] ?? null,
    bronze: distinct[2] ?? null,
  };
}
